import { getBackendBaseUrl } from './apiUtils';
import 'whatwg-fetch';

export const appointmentApi = async (token: string): Promise<Response> => {
  const telehealthBaseURL = getBackendBaseUrl();
  const data = await fetch(`${telehealthBaseURL}/appointment?token=${token}`);
  return data;
};
